@if (backgroundImage) {
    <img
        class="marquee-background-image"
        placeholder
        ngSrcset="1x, 2x, 3x"
        [width]="280"
        [height]="140"
        [ngSrc]="backgroundImage"
        [priority]="trackingPosition === 0" />
    <div [ngClass]="{ 'card-special-image': !tile.source?.isAutomatedMarquee, 'card-special-image-automated': tile.source?.isAutomatedMarquee }">
        <ng-container *ngTemplateOutlet="marqueeWithOptionCardTemplate" />
    </div>
} @else {
    <ng-container *ngTemplateOutlet="marqueeWithOptionCardTemplate" />
}

<ng-template #marqueeWithOptionCardTemplate>
    @if (!preventNavigation) {
        <a dsTouchClick [href]="url" [msRemoveHref]="shouldRemoveHref" (click)="tileClick()">
            <ng-container *ngTemplateOutlet="marqueeCardTemplate" />
        </a>
    } @else {
        <ng-container *ngTemplateOutlet="marqueeCardTemplate" />
    }

    <div class="marquee-card-footer mt-2">
        <div class="marquee-card-header marquee-card-event-timer">
            <ms-scoreboard-time class="card-date" [event]="tile.event" [style.color]="tile.source?.textColor" />
        </div>
        <div class="marquee-card-option-group mt-2" [class.empty-groups]="isOptionsEmpty">
            @if (!isOptionsEmpty && tileOptionGroup) {
                <ms-option-group
                    [optionGroup]="tileOptionGroup"
                    [event]="tile.event"
                    [tracking]="tracking"
                    [isOneWaySpecial]="false"
                    [optionNames]="overriddenOptionNames"
                    [disableOdds]="disableOdds"
                    [isFromPortal]="tile?.isFromPortal" />
            } @else {
                <ms-bet-now-button [event]="tile.event" />
            }
        </div>
    </div>

    <ng-template #marqueeCardTemplate>
        <div class="marquee-card-header">
            <div class="card-league regular-card-league" [title]="tile.event.league.name" [style.color]="tile.source?.textColor">
                <vn-icon name="sports-{{ tile.event.sport.id }}" class="icon-alignment" size="11" />
                <span>{{ tile.event.league.name }}</span>
            </div>
            <div class="correct-score-market-name" [title]="marketOverridenName" [style.color]="tile.source?.textColor">
                {{ marketOverridenName }}
            </div>
        </div>
        <div class="marquee-card-participants-with-score" [style.color]="tile.source?.textColor">
            @if (tile.event.participants.length > 1) {
                <div class="card-tennis-live marquee-card-participants correct-score-participants">
                    <div class="card-player card-player1">
                        <div class="player-name" [ngClass]="truncationPlayer" [title]="participant1Name" [style.color]="tile.source?.textColor">
                            {{ getParticipantName(0) }}
                        </div>
                        <ms-participant-image [participantImage]="tile.event.participants[0].image" [sportId]="tile.event.sport.id" />
                    </div>

                    <div class="card-player card-player2 marquee-card-participant">
                        <ms-participant-image
                            [shouldRotate]="true"
                            [participantImage]="tile.event.participants[1].image"
                            [sportId]="tile.event.sport.id" />
                        <div class="player-name" [ngClass]="truncationPlayer" [title]="participant2Name" [style.color]="tile.source?.textColor">
                            {{ getParticipantName(1) }}
                        </div>
                    </div>
                </div>
            }
            @if (tile.event.live) {
                <div class="card-tennis-live font-weight-bold" [style.color]="tile.source?.textColor" (click)="preventAction($event)">
                    <div class="cell">
                        <div>{{ participant1LiveScore }}</div>
                    </div>
                    <div class="cell marquee-card-participant">
                        <div class="p2-score">{{ participant2LiveScore }}</div>
                    </div>
                </div>
            }
            @if (tile.event.live) {
                <span class="vertical-line" [style.border-left-color]="tile.source?.textColor"></span>
            }

            <div class="card-tennis-live marquee-card-score" [style.color]="tile.source?.textColor" (click)="preventAction($event)">
                <ms-odd-increment-decrement
                    [position]="0"
                    [participantScore]="participant1Score"
                    [participantLiveScore]="participant1LiveScore"
                    (changeScoreEvent)="changeScoreEvent($event)" />
                <div class="marquee-card-participant-livescore">
                    <ms-odd-increment-decrement
                        [position]="1"
                        [participantScore]="participant2Score"
                        [participantLiveScore]="participant2LiveScore"
                        (changeScoreEvent)="changeScoreEvent($event)" />
                </div>
            </div>
        </div>
    </ng-template>
</ng-template>
